module.exports = __webpack_public_path__ + "img/completion7.efa83579.svg";